/**
 * @returns Timestamp in miliseconds
 */
export const getTimestamp = () => 
// @ts-ignore
typeof performance !== "undefined" ? performance.now() : new Date().getTime();
export function formatMilliseconds(ms) {
    return ms > 999 ? (ms / 1000).toFixed(1) + "s" : ms.toFixed(2) + "ms";
}
//# sourceMappingURL=time.js.map